import { render } from "./TrainingTrainingCourseComponent.vue?vue&type=template&id=82f6107a&scoped=true"
import script from "./TrainingTrainingCourseComponent.vue?vue&type=script&lang=js"
export * from "./TrainingTrainingCourseComponent.vue?vue&type=script&lang=js"

import "./TrainingTrainingCourseComponent.vue?vue&type=style&index=0&id=82f6107a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82f6107a"]])

export default __exports__